export const CARD_HEAD_STYLES = {
  border: 'none',
};

export const CARD_BODY_STYLES = {
  paddingTop: 0,
};
